module.exports = __webpack_public_path__ + "static/media/27OCHA17.dad2b41a.jpg";